// removed by extract-text-webpack-plugin
module.exports = {"fontAll":"jsbB_c48qtci5CrZIo5bf"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/App.css
// module id = 336
// module chunks = 0